import { yupResolver } from '@hookform/resolvers/yup';
import { useRescheduleHotelSale } from 'api-hooks/sale/hotel';
import { SaleDetailModel } from 'api-hooks/sale/model';
import { NavigationRoutes } from 'common/constants';
import formSetErrors from 'common/helpers/form-setError';
import notification from 'components/common/notification';
import Separator from 'components/common/separator';
import { Form, Input } from 'components/elements';
import FormHeader from 'components/widgets/form-header';
import useNavigation from 'hooks/use-navigation';
import {
  FormContent,
  FormDivider,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useForm } from 'react-hook-form';

import {
  HotelRescheduleFormSchema,
  HotelRescheduleFormType,
} from './form-type';
import useGetDefaultValues from './hooks/use-get-default-values';
import HotelItems from './items';
import SummaryHotelReschedule from './summary';
import RescheduleHistoryTable from '../reschedule-history-table';

interface Props {
  hotelSale: SaleDetailModel;
}

export default function HotelRescheduleForm(props: Props) {
  const { t } = useTranslation();
  const { hotelSale } = props;
  const { navigate, close } = useNavigation();

  const { mutateAsync } = useRescheduleHotelSale();
  const defaultValues = useGetDefaultValues(hotelSale);
  const methods = useForm<HotelRescheduleFormType>({
    defaultValues,
    resolver: yupResolver(HotelRescheduleFormSchema()),
    mode: 'onChange',
  });

  const onCancel = () => {
    close();
    navigate(NavigationRoutes.HotelSalesView, {
      id: hotelSale.id,
    });
  };

  const onSubmit = async (values: HotelRescheduleFormType) => {
    try {
      //if error can submit again
      const hotelSales = values.hotelSales
        .filter((curr) => curr.isSelected)
        .map((fs) => ({
          ...fs,
          isSelected: undefined,
          hotelSaleGuests: fs.hotelSaleGuests.map((fsg) => ({
            ...fsg,
            preferences: (fsg.preferences || []).map(
              (preference) => preference.id,
            ),
          })),
        }));

      await mutateAsync({
        hotelSaleId: hotelSale.id,
        body: { ...values, hotelSales },
      });
      onCancel();
    } catch (e) {
      if (e.errors) {
        formSetErrors(e.errors, methods.setError);
      }
      notification.error({ message: e.message });
    }
  };

  return (
    <Form
      methods={methods}
      onSubmit={onSubmit}
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      noReset
    >
      <FormContent>
        <FormHeader
          title={t('reschedule:reschedule_hotel')}
          data={hotelSale}
          noDelete
          onCancel={onCancel}
        />
        <div>
          <SectionContainer>
            <HalfContainer>
              <Input
                type="text"
                name="invoiceNumber"
                label={t('common:invoice_number')}
                disabled
              />
            </HalfContainer>
            <HalfContainer>
              <Input
                type="text"
                name="customer"
                label={t('common:customer')}
                disabled
              />
            </HalfContainer>
          </SectionContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="transactionAt"
              label={t('common:transaction_at')}
              clearable={false}
              required
            />
          </HalfContainer>
          <Separator gap={32} direction="vertical">
            <RescheduleHistoryTable type="hotel" saleId={hotelSale.id} />
          </Separator>

          <Separator gap={16} direction="vertical">
            <HotelItems />
          </Separator>
          <FormDivider />
        </div>
      </FormContent>
      <SummaryHotelReschedule />
    </Form>
  );
}
